export default __webpack_public_path__ + "static/media/Inter-BoldItalic.6b5fde51.woff";